import { Box, BoxProps } from "@chakra-ui/react";
import { FiChevronDown } from "react-icons/fi";

export const ChevronDown = (props: BoxProps) => {
  return <Box as={FiChevronDown} height="20px" width="20px" {...props} />;
};
